import { Box, Paper } from '@mui/material';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

const TestrunTooltip = ({ testrunsData, series, total, dataIndex, mode, totalArr }) => {
    const { data } = series;
    const { t } = useTranslation();

    const [labelsColumn, valuesColumn] = useMemo(() => {
        switch (mode) {
            case 'testrun': {
                return [
                    data.map((item) => {
                        const result = item.label.split('\n')[0];
                        return (
                            <Box sx={{ display: 'flex', gap: 0.5, alignItems: 'center' }}>
                                <Box sx={{ width: 8, height: 8, backgroundColor: item.color }}></Box>
                                <Box>{result}:</Box>
                            </Box>
                        );
                    }),
                    data.map((item) => {
                        const percent = item.label.split('\n')[1];
                        return (
                            <Box>
                                {percent} ({item.value} {t('of')} {total})
                            </Box>
                        );
                    }),
                ];
            }
            case 'history': {
                if (!testrunsData || !testrunsData[dataIndex]) {
                    return [[], []];
                }

                const testrunData = testrunsData[dataIndex];
                const total = totalArr?.[dataIndex];

                return [
                    series.map((item) => {
                        return (
                            <Box key={item.label} sx={{ display: 'flex', gap: 0.5, alignItems: 'center' }}>
                                <Box sx={{ width: 8, height: 8, backgroundColor: item.color }}></Box>
                                <Box>{item.label}:</Box>
                            </Box>
                        );
                    }),
                    series.map((item, index) => {
                        const percent = item.data[dataIndex];
                        const fieldNames = [
                            'failed_cnt',
                            'deploy_failed_cnt',
                            'failed_na_cnt',
                            'broken_cnt',
                            'passed_cnt',
                            'blocked_cnt',
                            'not_found_cnt',
                        ];
                        const actualValue = testrunData[fieldNames[index]] || 0;
                        return (
                            <Box key={`${item.label}-${index}`}>
                                {percent}% ({actualValue} {t('of')} {total || 0})
                            </Box>
                        );
                    }),
                ];
            }
            case 'duration': {
                return [
                    series.map((item, index) => {
                        return (
                            <Box key={`duration-${index}`} sx={{ display: 'flex', gap: 0.5, alignItems: 'center' }}>
                                <Box sx={{ width: 8, height: 8, backgroundColor: item.color }}></Box>
                                <Box>{t('duration')}:</Box>
                            </Box>
                        );
                    }),
                    series.map((item, index) => {
                        const rawValue = item.data[dataIndex];
                        const roundedValue = Number(rawValue).toFixed(1);
                        return <Box key={`duration-value-${index}`}>{item.valueFormatter(roundedValue)}</Box>;
                    }),
                ];
            }
            default: {
                return [[], []];
            }
        }
    }, [data, dataIndex, mode, series, t, total, totalArr, testrunsData]);

    if (!labelsColumn || labelsColumn.length === 0) {
        return null;
    }

    return (
        <Paper elevation={4} sx={{ p: 1, display: 'flex', flexDirection: 'column', gap: 1 }}>
            <Box sx={{ display: 'flex', gap: 1, color: 'text.primary' }}>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>{labelsColumn}</Box>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, textAlign: 'right' }}>{valuesColumn}</Box>
            </Box>
        </Paper>
    );
};

export default TestrunTooltip;
